function btyOnVariantChange({ target }) {
	// Only react to variant picker fields. Quantity / calculator inputs also
	// bubble `change` inside `.template-product` and must not trigger a fetch.
	if (!target || !target.classList.contains('field-value')) {
		return;
	}

	const isRadio = target.type === 'radio';
	const isSelect = target.tagName.toLowerCase() === 'select';
	if (!isRadio && !isSelect) {
		return;
	}

	const main = this.querySelector('main');
	const product = this.querySelector('.main-product');
	const recentlyViewed = this.querySelector('.product-recently-viewed');
	const currentProductUrl = product ? product.dataset.productUrl : null;
	const variantsRoot = product ? product.querySelector('.product-variants:first-child') : null;

	if (!main || !product || !variantsRoot) {
		return;
	}

	let productUrl;
	let variantId;
	let firstOptionProductUrl;
	let uniqueProductUrls = [];

	if (isRadio) {
		productUrl = target.dataset.productUrl;
		variantId = target.dataset.variantId;
		uniqueProductUrls = Array.from(this.querySelectorAll('.variant-field input'))
			.map((input) => input.dataset.productUrl)
			.filter((url) => url && url.trim() !== '')
			.filter((url, index, list) => list.indexOf(url) === index);

		const firstChecked = variantsRoot.querySelector('.variant-field:first-child input:checked');
		firstOptionProductUrl = firstChecked ? firstChecked.dataset.productUrl : null;
	}

	if (isSelect) {
		const selectedOption = target.selectedOptions[0];
		if (!selectedOption) {
			return;
		}

		productUrl = selectedOption.dataset.productUrl;
		variantId = selectedOption.dataset.variantId;
		uniqueProductUrls = Array.from(this.querySelectorAll('.variant-field select option'))
			.map((option) => option.dataset.productUrl)
			.filter((url) => url && url.trim() !== '')
			.filter((url, index, list) => list.indexOf(url) === index);

		const firstSelected = variantsRoot.querySelector('.variant-field:first-child select option:checked');
		firstOptionProductUrl = firstSelected ? firstSelected.dataset.productUrl : null;
	}

	if (!productUrl) {
		return;
	}

	let params = '';
	if (variantId) {
		params += `variant=${variantId}`;
	}

	const reinitProductPage = () => {
		btyAnimationImageLoad();
		btyPhotoswipeHandle();
		btyProductVariants();
		btyProductPerformed();
		btyQuantityButton();
		btyAddToCart();
		btyProductPopup();
		btyProductGallery();
		if (recentlyViewed) {
			btyRecentlyProduct();
		}
	};

	fetch(`${productUrl}?${params}`)
		.then(function (response) {
			if (200 !== response.status) {
				console.log('Status Code: ' + response.status);
				throw response;
			}

			return response.text();
		})
		.then(function (html) {
			if (productUrl && currentProductUrl !== productUrl) {
				main.innerHTML = btyGetSectionHtml(html, 'main');
				if (variantId) {
					window.history.replaceState({}, '', productUrl + '?variant=' + variantId);
				} else {
					window.history.replaceState({}, '', productUrl);
				}
				return;
			}

			if (uniqueProductUrls.length > 0 && !uniqueProductUrls.includes(currentProductUrl) && firstOptionProductUrl) {
				fetch(`${firstOptionProductUrl}?${params}`)
					.then(function (response) {
						if (200 !== response.status) {
							console.log('Status Code: ' + response.status);
							throw response;
						}

						return response.text();
					})
					.then(function (html) {
						main.innerHTML = btyGetSectionHtml(html, 'main');
						if (variantId) {
							window.history.replaceState({}, '', firstOptionProductUrl + '?variant=' + variantId);
						} else {
							window.history.replaceState({}, '', firstOptionProductUrl);
						}
					})
					.finally(reinitProductPage);
			}
		})
		.finally(reinitProductPage);
}

function btyCombinedProduct(doc = document) {
	const templates = doc.querySelectorAll('.template-product');
	if (!templates.length) {
		return;
	}

	templates.forEach(function (template) {
		template.addEventListener('change', btyOnVariantChange);
	});
}

document.addEventListener('DOMContentLoaded', function () {
	if (window.ProductModel) {
		window.ProductModel.loadShopifyXR();
	}
	btyCombinedProduct();
});

document.addEventListener('shopify:section:load', function (event) {
	btyCombinedProduct(event.target.closest('section.shopify-section'));
});

document.addEventListener('shopify:section:select', function (event) {
	btyCombinedProduct(event.target);
});

document.addEventListener('shopify:block:select', function (event) {
	const section = event.target.closest('.shopify-section');
	if (section) {
		btyCombinedProduct(section);
	}
});
